import {useList} from "@refinedev/core"
import IType from "../interfaces/IType"

export const TYPE_RESOURCE = 'type'

export function getTypes() {
    const {data: typesData, isLoading: isTypesLoading, error: typesError} = useList<IType>({
        resource: TYPE_RESOURCE,
        meta: {resourceName: 'types'}
    })
    return {types: typesData?.data ?? [], isTypesLoading, typesError}
}
